import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import {
  SearchBoxDefinition,
  SearchBoxProps,
} from '@wix/thunderbolt-components';

import { ISearchBoxMapperProps } from '../SearchBox.types';
import { props as viewerPropsMapper } from './SearchBox.mapper';

const props = composeMapper<
  ISearchBoxMapperProps,
  SearchBoxDefinition,
  SearchBoxProps
>()(
  viewerPropsMapper,
  { add: ['compPreviewState'] },
  (resolver, deps, carmiProps) => {
    const viewerProps = resolver(deps, carmiProps);
    const { compPreviewState } = deps;

    return {
      ...viewerProps,
      previewWrapperProps: { compPreviewState },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
